import { store } from "../reducers/store";

export const checkPermission = ({ permission, permissionType }) => {
  try {
    const state = store.getState();

    if (!state.permissions || !state.permissions.hasLoadedpermissions) {
      throw new Error("Permissions have not been loaded yet.");
    }

    const permissionsobj = state.permissions.data;

    if (!permissionsobj || !permissionsobj[permission]) {
      throw new Error(`Permission "${permission}" not found.`);
    }

    const permissionValue = permissionsobj[permission][permissionType];

    if (permissionValue === undefined) {
      throw new Error(
        `Permission type "${permissionType}" not found for permission "${permission}".`
      );
    }

    return permissionValue;
  } catch (error) {
    console.error("Error checking permission:", error.message);
    return false;
  }
};
